import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { Route } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AppTemplateModule } from '../app-template/app-template.module';
import { AppTab } from '../app-template/models/app-tab.model';
import { MainAppService } from '../app-template/services/main-app.service';
import { PrimeModule } from '../prime/prime.module';
import { AdminPageDefinition } from '../sm-base/models/admin-page-definition.model';
import { FeatureModule } from '../sm-base/models/feature.module';
import { SmTimer } from '../sm-base/models/sm-timer.model';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { CalendarEventToolTipComponent } from './components/calendar-event-tool-tip/calendar-event-tool-tip.component';
import { EditCalendarEventAppointmentComponent } from './components/edit-calendar-event-appointment/edit-calendar-event-appointment.component';
import { EditCalendarEventForProjectComponent } from './components/edit-calendar-event-for-project/edit-calendar-event-for-project.component';
import { EditCalendarEventTemplateComponent } from './components/edit-calendar-event-template/edit-calendar-event-template.component';
import { EditCalendarEventTemplatesComponent } from './components/edit-calendar-event-templates/edit-calendar-event-templates.component';
import { EditCalendarEventTypeComponent } from './components/edit-calendar-event-type/edit-calendar-event-type.component';
import { EditCalendarEventTypesComponent } from './components/edit-calendar-event-types/edit-calendar-event-types';
import { EditCalendarOutlineLevelComponent } from './components/edit-calendar-outline-level/edit-calendar-outline-level.component';
import { EditCalendarOutlineLevelsComponent } from './components/edit-calendar-outline-levels/edit-calendar-outline-levels';
import { EditCalendarOutlineTemplateTableComponent } from './components/edit-calendar-outline-template-table/edit-calendar-outline-template-table.component';
import { EditCalendarOutlineTemplateComponent } from './components/edit-calendar-outline-template/edit-calendar-outline-template.component';
import { EditCalendarOutlineTemplatesComponent } from './components/edit-calendar-outline-templates/edit-calendar-outline-templates.component';
import { EditCalendarRoleComponent } from './components/edit-calendar-role/edit-calendar-role.component';
import { EditCalendarRolesComponent } from './components/edit-calendar-roles/edit-calendar-roles.component';
import { EditNetworkLinkedDocumentComponent } from './components/edit-network-linked-document/edit-network-linked-document.component';
import { EditNetworkLinkedDocumentCategoryComponent } from './components/edit-network-linked-document-category/edit-network-linked-document-category.component';
import { EditNetworkLinkedDocumentCategoriesComponent } from './components/edit-network-linked-document-categories/edit-network-linked-document-categories';
import { EditProjectCustomFieldDefinitionComponent } from './components/edit-project-custom-field-definition/edit-project-custom-field-definition.component';
import { EditProjectCustomFieldDefinitionsComponent } from './components/edit-project-custom-field-definitions/edit-project-custom-field-definitions.component';
import { EditProjectResponsibilitiesComponent } from './components/edit-project-responsibilities/edit-project-responsibilities.component';
import { EditProjectTemplateComponent } from './components/edit-project-template/edit-project-template.component';
import { EditProjectTemplatesComponent } from './components/edit-project-templates/edit-project-templates.component';
import { EditProjectTypeComponent } from './components/edit-project-type/edit-project-type.component';
import { EditProjectTypesComponent } from './components/edit-project-types/edit-project-types';
import { EditProjectComponent } from './components/edit-project/edit-project.component';
import { EditProjectsComponent } from './components/edit-projects/edit-projects.component';
import { EditResourceTypeComponent } from './components/edit-resource-type/edit-resource-type.component';
import { EditResourceTypesComponent } from './components/edit-resource-types/edit-resource-types';
import { EditResourceComponent } from './components/edit-resource/edit-resource.component';
import { EditResourcesComponent } from './components/edit-resources/edit-resources.component';
import { PlanningViewCompanyComponent } from './components/planning-view-company/planning-view-company.component';
import { PlanningViewDocumentsComponent } from './components/planning-view-documents/planning-view-documents.component';
import { PlanningViewMyWorkspaceComponent } from './components/planning-view-my-workspace/planning-view-my-workspace.component';
import { PlanningViewProjectOverviewComponent } from './components/planning-view-project-overview/planning-view-project-overview.component';
import { PlanningViewProjects1Component } from './components/planning-view-projects1/planning-view-projects1.component';
import { PlanningViewProjects2Component } from './components/planning-view-projects2/planning-view-projects2.component';
import { ProjectInformationComponent } from './components/project-information/project-information.component';
import { ProjectDocumentsComponent } from './components/project-documents/project-documents.component';
import { ProjectPlanningMainComponent } from './components/project-planning-main/project-planning-main.component';
import { ProjectToolbarComponent } from './components/project-toolbar/project-toolbar.component';
import { ProjectPlanningTools } from './models/project-planning-tools.model';
import { ProjectPlanningRoutingModule } from './project-planning-routing.module';
import { ProjectPlanningService } from './services/project-planning.service';

@NgModule({
  declarations: [
    EditCalendarEventTypeComponent,
    EditCalendarEventTypesComponent,
    EditCalendarEventTemplatesComponent,
    EditCalendarEventTemplateComponent,
    EditCalendarOutlineLevelsComponent,
    EditCalendarOutlineLevelComponent,
    EditCalendarOutlineTemplatesComponent,
    EditCalendarOutlineTemplateComponent,
    EditCalendarRolesComponent,
    EditCalendarRoleComponent,
    EditCalendarEventForProjectComponent,
    EditCalendarEventAppointmentComponent,
    EditNetworkLinkedDocumentComponent,
    EditNetworkLinkedDocumentCategoryComponent,
    EditNetworkLinkedDocumentCategoriesComponent,
    EditProjectsComponent,
    EditProjectComponent,
    EditProjectTypesComponent,
    EditProjectTypeComponent,
    EditProjectTemplatesComponent,
    EditProjectTemplateComponent,
    EditProjectCustomFieldDefinitionsComponent,
    EditProjectCustomFieldDefinitionComponent,
    EditResourceComponent,
    EditResourcesComponent,
    EditResourceTypesComponent,
    EditResourceTypeComponent,
    ProjectPlanningMainComponent,
    PlanningViewProjects1Component,
    PlanningViewProjects2Component,
    PlanningViewMyWorkspaceComponent,
    PlanningViewCompanyComponent,
    PlanningViewProjectOverviewComponent,
    PlanningViewDocumentsComponent,
    EditCalendarOutlineTemplateTableComponent,
    CalendarEventToolTipComponent,
    ProjectInformationComponent,
    ProjectDocumentsComponent,
    EditProjectResponsibilitiesComponent,
    ProjectToolbarComponent
  ],
  imports: [
    AppTemplateModule,
    CommonModule,
    PrimeModule,
    SmBaseModule,
    FullCalendarModule
  ]
})
export class ProjectPlanningModule implements FeatureModule {

    app = inject(MainAppService);
    featureModuleService = inject(FeatureModuleService);
    service = inject(ProjectPlanningService);

    trackChangesTimer: SmTimer;

    constructor() {
        this.featureModuleService.register(this);
    }

    getId(): string {
        return "ProjectPlanningModule";
    }
    
    async beforeAppStart(): Promise<void> {  
        this.app.registerChangesCallback(this.service.trackChanges.bind(this.service), "ProjectPlanningModule", -100);     
    } 

    registerSidebar(_: AppTab[]): void {
    }

    
    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("project-planning", () => ProjectPlanningRoutingModule);
    }

    getAdminPages(): AdminPageDefinition[] {
        return [
            ProjectPlanningTools.definitionCalendarEventType.getAdminPage(),
            ProjectPlanningTools.definitionCalendarEventTemplate.getAdminPage(),
            ProjectPlanningTools.definitionCalendarOutlineLevel.getAdminPage(),
            ProjectPlanningTools.definitionCalendarOutlineTemplate.getAdminPage(),
            ProjectPlanningTools.definitionCalendarRole.getAdminPage(),
            ProjectPlanningTools.definitionProjectCustomFieldDefinition.getAdminPage(),
            ProjectPlanningTools.definitionProjectType.getAdminPage(),
            ProjectPlanningTools.definitionProjectTemplate.getAdminPage(),
            ProjectPlanningTools.definitionResourceType.getAdminPage(),
            ProjectPlanningTools.definitionResource.getAdminPage(),
            ProjectPlanningTools.definitionNetworkLinkedDocumentCategory.getAdminPage(),
          //  ProjectPlanningTools.definitionProject.getAdminPage()
        ];
    }
}
